import Maintenance41_2Header from "./Header";
import "./index.css";
import { useState } from "react";
import InputsFromMaintenance41_2a from "../ProdUseStage41/InputsFromMaintenance41_2a";
import SurplusResourcesMaintenance41_2b from "../ProdUseStage41/SurplusResourcesMaintenance41_2b";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdMaintenance41_2Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const [totalProdItem, setTotalProdItem] = useState([]);

  return (
    <div className="prod-maintenance-41-2-container" id="prod-maintenance-41-2-id">
      <Maintenance41_2Header
        productId={productId}
        show={show}
        totalProdItem={totalProdItem}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <InputsFromMaintenance41_2a productId={productId} />
          <SurplusResourcesMaintenance41_2b productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdMaintenance41_2Components;

